import { BinLocationLight, MovableRackReference, StackBinLevel } from './bin.model';
import { PN } from '../pn.model';
import { TyreCustomer } from '../tyreCustomer.model';

export enum PackingType {
  RACK = 'RACK',
  STACK = 'STACK'
}

export const isRack = (packingType: PackingType) => {
  return packingType === PackingType.RACK;
};

export const isStack = (packingType: PackingType) => {
  return packingType === PackingType.STACK;
};


export interface PackingLight {
  id: number;
  reference: string;
  type: PackingType;
  rackType?: MovableRackReference;
  rackLevel?: number;
  stackLevel?: StackBinLevel;
  maxAllowedTyre: number;
  pn: PN;
  tyreCustomers: TyreCustomer[];
}

export interface Packing extends PackingLight {
  tyreSnList: string[];
  binLocation: BinLocationLight;
}

export enum PackingFillRate {
  EMPTY = 'EMPTY',
  PARTIAL = 'PARTIAL',
  NEARFULL = 'NEARFULL',
  FULL = 'FULL'
}
